import React from "react"
import { TableContextProvider } from "./provider"

import { DataTable } from "./DataTable"
import { TableProps } from "./types"
import { InitializerPageSize } from "./DataTable/initializers/InitializerPageSize"
import { InitializerFilters } from "./DataTable/initializers/InitializerFilters"
import { InitializerSorting } from "./DataTable/initializers/InitializerSorting"
import { InitializerHeight } from "./DataTable/initializers/InitializerHeight"

export const ProgressTable = (props: TableProps) => {

  return (
    <TableContextProvider {...props}>

      <InitializerHeight />
      <InitializerPageSize />
      <InitializerFilters />
      <InitializerSorting />

      <DataTable />

    </TableContextProvider>
  )
}

export * from "./types"